import { clearPromoDisplayValue } from '../authModal/postAuth/containers/marketingOptIn/helpers/useIntlMarketingOptInPromoDisplayValue';

const clearVariantControlPromo = (): void => {
    clearPromoDisplayValue();
    for (const [key] of Object.entries({ ...localStorage })) {
        if (key.includes('geoLocationPromoGroup:')) {
            localStorage.removeItem(key);
        }
    }
};

export default clearVariantControlPromo;
